import React, { Component } from 'react';
import { View, Text, ScrollView, StyleSheet,  Picker, Button, Dimensions } from 'react-native';
import {  ButtonGroup } from 'react-native-elements';
import { Table, Row } from 'react-native-table-component';
const { width, height } = Dimensions.get('window');

import axios from 'axios';
import UserPersistence from '../singletons/UserPersistence';
import config from '../../config'
import { TouchableOpacity } from 'react-native-web';
import MonthlyBillingTable from '../components/monthlyBillingTableComponent/monthBillingTableComponent';
import InvoiceHistoryTable from '../components/invoiceHistoryTableComponent/invoiceHistoryTableComponent';
import CreditCards from '../components/creditCardComponent/creditCardComponent';

class Bills extends Component{
    
    constructor(props){
        super(props);
        this.state = {
            selectedIndex: 0,
            tableHead:['Month', 'Invoice', 'Service Fee', 'Late Fee', 'Total Charge', 'Check/Card Transaction', 'Credit', 'Paid Amount', 'Receive Date', 'Balance', 'Download'],
            widthArr:['8%','8%','7%','7%','8%','20%','8%','8%','8%','8%','10%'],
            title: ['Monthly Billing History','Download Installation Invoices','Credit Cards Management'],
            allMonthlyBills: [],
            combineMonthlyBills: [],
            allInvoiceNumber: [],
            combineInvoiceNumber: [],
            allCreditCardInfo: [],
            contractId: [],
        }

    }

    async componentDidMount() {
        this.focusListener = this.props.navigation.addListener('didFocus', () => {
            this.onFocusFunction();
        });
    }

    componentWillUnmount() {
        this.focusListener.remove();
    }
    onFocusFunction() {
        if (UserPersistence.getInstance().userId == null) {
            return;
        }
        this.getAllMonthlyBills();
    }

    swichButtonGroup = (selectedIndex) => {
        this.state.selectedIndex = selectedIndex;
        if(selectedIndex===0){
            console.log(`current selectedIndex is 0`)
            this.goToBill();
            this.getAllMonthlyBills()
        }else if(selectedIndex===1){
            console.log(`current selectedIndex is 1`);
            this.goToInvoice();
            this.getAllInvoiceNumber()
        }else if(selectedIndex===2){
            console.log(`current selectedIndex is 2`)
            this.goToCreditCard();
            this.getAllCreditCardInfoByUserName();
        }
    }

    goToBill = () => {
        if(this.state.selectedIndex===0){
            this.setState({
                tableHead:['Month', 'Invoice', 'Service Fee', 'Late Fee', 'Total Charge', 'Check/Card Transaction', 'Credit', 'Paid Amount', 'Receive Date', 'Balance', 'Download'],
                widthArr:['8%','8%','8%','8%','8%','20%','8%','8%','8%','8%','8%'],
                allMonthlyBills: [],
                combineMonthlyBills: [],
            })
        }
    }

    goToInvoice = () => {
        if(this.state.selectedIndex===1){
            this.setState({
                tableHead:['Invoice', 'Vehicles', 'download'],
                widthArr:['10%','80%','10%'],
                allInvoiceNumber: [],
                combineInvoiceNumber: [],
            })
        }
    }

    goToCreditCard = () => {
        if(this.state.selectedIndex===2){
            this.setState({
                tableHead: ['Add a new credit card'],
                widthArr: ['100%'],
                // allInvoiceNumber: [],
                // combineInvoiceNumber: [],
            })
        }
    }

    getAllMonthlyBills = () => {
        const username = UserPersistence.getInstance().userName;
        axios
            .get(
                config.user.protocol+
                config.user.address+
                ':'+
                config.user.port+
                '/getAllMonthlyBills'+
                '?userName='+
                username,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Auth-User': UserPersistence.getInstance().userId,
                        'X-Auth-Token': UserPersistence.getInstance().userAccessToken,
                    },
                }
            )
            .then(res => {
                if(this.isResponseOk(res)){
                    this.setState({
                        allMonthlyBills: res.data,
                    })

                    console.log(this.state.allMonthlyBills);

                    this.combineBills();
                }else {
                    alert('no reply')
                }
            })
    }

    getAllInvoiceNumber = () => {
        const username = UserPersistence.getInstance().userName;
        axios
            .get(
                config.user.protocol+
                config.user.address+
                ':'+
                config.user.port+
                '/getAllInvoiceNumber'+
                '?userName='+
                username,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Auth-User': UserPersistence.getInstance().userId,
                        'X-Auth-Token': UserPersistence.getInstance().userAccessToken,
                    },
                }
            )
            .then(res => {
                if(this.isResponseOk(res)){
                    this.setState({
                        allInvoiceNumber: res.data,
                    })

                    console.log(this.state.allInvoiceNumber);
                    this.convertToArray();
                }else {
                    alert('no reply')
                }
            })
    }

    getAllCreditCardInfoByUserName = () => {
        const username = UserPersistence.getInstance().userName;
        axios
            .get(
                config.user.protocol+
                config.user.address+
                ':'+
                config.user.port+
                '/getCreditCardInfoByUserName'+
                '?userName='+
                username,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Auth-User': UserPersistence.getInstance().userId,
                        'X-Auth-Token': UserPersistence.getInstance().userAccessToken,
                    },
                }
            )
            .then(res => {
                if(this.isResponseOk(res)){
                    this.setState({
                        allCreditCardInfo: res.data,
                    })
                    console.log('credit card info: '+this.state.allCreditCardInfo[2])
                    this.getUserContractId()
                }else {
                    alert('no reply')
                }
            })
    }

    getUserContractId = () => {
        const username = UserPersistence.getInstance().userName;

        axios
        .get(
            config.user.protocol+
            config.user.address+
            ':'+
            config.user.port+
            '/getUserContractByUserName'+
            '?userName='+
            username,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'X-Auth-User': UserPersistence.getInstance().userId,
                    'X-Auth-Token': UserPersistence.getInstance().userAccessToken,
                },
            }
        )
        .then(res => {
            if(this.isResponseOk(res)){
                this.setState({
                    contractId: res.data,
                })

                console.log(this.state.contractId);
            }else {
                alert('no reply')
            }
        })
    }


    isResponseOk = (res) => {
        if (res.status == 200 && res.data != null) {
            return true;
        } else {
            return false;
        }
    }

    //处理请求获得的allmonthlybills 将有用的字段处理后放入combineMonthlyBills中
    combineBills = () => {
        const allMonthlyBills = this.state.allMonthlyBills.reverse();
        const result = [];

        allMonthlyBills.map((allMonthlyBill)=>{
            result.push({
                month: allMonthlyBill.month,
                invoice: allMonthlyBill.invoice,
                servicefee: allMonthlyBill.monthCharge,
                lateFee: allMonthlyBill.lateFee,
                totalFee: allMonthlyBill.amount,
                checkCardTransaction: allMonthlyBill.clientCheck,
                credit: allMonthlyBill.credit,
                paidAmount: allMonthlyBill.clientPayment,
                receiveDate: allMonthlyBill.time.trim().substring(0,10),
                balance: allMonthlyBill.balance,
                download: (<TouchableOpacity onPress={ ()=> alert('download a pdf file')}>
                                <Text style={[styles.rowText,{textDecorationLine: 'underline'}]}>
                                    {allMonthlyBill.invoice.trim()}
                                </Text>
                            </TouchableOpacity>)
            })
        })
        
        this.setState({
            combineMonthlyBills: result,
        })
    }


    //将请求获取的allInvoiceNumber转换成hashmap的形式 相同的invoiceNumber作为key 对应nickname
    convertToHashMap = () => {
        const readyArr = this.state.allInvoiceNumber;
        const hashMap = {};

        readyArr.forEach( item => {
            const { invoiceNumber, nickName } = item

            if(hashMap[invoiceNumber.trim()]){
                hashMap[invoiceNumber.trim()].push(nickName.trim());
            }else{
                hashMap[invoiceNumber.trim()] = [nickName.trim()];
            }
        })

        console.log(hashMap)
        return hashMap;
    }

    convertToArray = () => {
        const hashMap = this.convertToHashMap();

        const dataArray = Object.entries(hashMap).map(([invoiceNumber, nicknames]) => ({
            invoiceNumber,
            nickNames: nicknames.join('/ '),
            download: (<TouchableOpacity onPress={ ()=> alert('download a pdf file')}>
                            <Text style={[styles.rowText,{textDecorationLine: 'underline'}]}>
                                {invoiceNumber}
                            </Text>
                        </TouchableOpacity>)
        }));
        console.log(dataArray);
        this.setState({
            combineInvoiceNumber: dataArray,
        })
    }


    //将字符串转换正保留两位的浮点数
    convertStringToDouble = (str) => {
        const roundedNum = parseFloat(str).toFixed(2);
        // console.log(roundedNum);
        return parseFloat(roundedNum)
    }
    //计算全部bills的balance monthlyfee latefee 根据balance的值返回text组件的内容
    caculateBalance = () => {
        const allMonthlyBills = this.state.allMonthlyBills;
        let totalServiceFee = 0, totalLateFee=0, totalBalance = 0;
        allMonthlyBills.map(allMonthlyBill=>{
            totalServiceFee += this.convertStringToDouble(allMonthlyBill.monthCharge);
            totalLateFee += this.convertStringToDouble(allMonthlyBill.lateFee);
            totalBalance += this.convertStringToDouble(allMonthlyBill.balance);
        })

        if(totalBalance>0){
            return (
                <Text style={[styles.balanceText, {color: 'red'}]}>
                    Total unpaid service fee: {totalServiceFee.toFixed(2)}, Late fee: {totalLateFee.toFixed(2)}, Current balance: {totalBalance.toFixed(2)};
                </Text>
                )
        }else if(totalBalance==0){
            return (
                <Text style={[styles.balanceText, {color: 'green'}]}>
                    Balance: {totalBalance.toFixed(2)}
                </Text>
            );
        }
    }
    //确定table中数据
    dataArr = (data) => {
        if(this.state.selectedIndex===0){
            return[
                data.month,
                data.invoice,
                data.servicefee,
                data.lateFee,
                data.totalFee,
                data.checkCardTransaction,
                data.credit,
                data.paidAmount,
                data.receiveDate,
                data.balance,
                data.download,
            ]
        }
        if(this.state.selectedIndex===1){
            return[
                data.invoiceNumber,
                data.nickNames,
                data.download
            ]
        }
    }

    updateAllCreditCardInfo = () => {
        this.getAllCreditCardInfoByUserName();
    }

    render(){
        return(
            <ScrollView>
                <View>
                    <View style={[styles.buttonGroupContainer]}>
                        <ButtonGroup
                            buttons={['Monthly Bill','Deposit Invoice','Credit Card']}
                            selectedIndex={this.state.selectedIndex}
                            onPress={ selectedIndex => { this.swichButtonGroup(selectedIndex) }}
                            containerStyle={{width:'70%', marginBottom: 20 }}
                        />
                    </View>
                    <View style={styles.titleContainer}>
                        <Text style={styles.title}>{this.state.title[this.state.selectedIndex]}</Text>
                    </View>
                    {this.state.selectedIndex===0 && 
                        (<MonthlyBillingTable 
                            caculateBalance = {this.caculateBalance}
                            tableHead = {this.state.tableHead}
                            widthArr = {this.state.widthArr}
                            combineMonthlyBills = {this.state.combineMonthlyBills}
                            dataArr = {this.dataArr}
                        />)
                    }
                    {this.state.selectedIndex===1 && 
                        (<InvoiceHistoryTable
                            tableHead = {this.state.tableHead}
                            widthArr = {this.state.widthArr}
                            combineInvoiceNumber = {this.state.combineInvoiceNumber}
                            dataArr = {this.dataArr}
                        />)
                    }
                    {this.state.selectedIndex === 2 && this.state.allCreditCardInfo.length!=0 && this.state.contractId.length!=0 &&
                        (<CreditCards 
                            allCreditCardInfo = {this.state.allCreditCardInfo}
                            contractId={this.state.contractId}
                            updateAllCreditCardInfo={this.updateAllCreditCardInfo}
                        />)
                    }
                    
                </View>
            </ScrollView>
        )
    }
}

const styles = StyleSheet.create({
    buttonGroupContainer:{
        flexDirection: 'row',
        justifyContent: 'space-around',
        width: '100%',
        marginRight: 5,
        marginLeft: 5,
        marginTop: 5,
        textAlign: 'center',
    },
    titleContainer:{
        alignItems: 'center',
        padding:10,
    },
    title: {
        fontSize: 16,
        fontWeight: 'bold',
        textAlign: 'center'
    },

    // balanceCotainer:{
    //     padding:20,
    //     alignItems: 'flex-end'
    // },

    balanceText:{
        fontSize: 18,
        fontWeight: '600',
    },

    // tableContainer:{
    //    padding: 20,
    // },

    // row:{
    //     backgroundColor: '#1e5d8a'
    // },
    // headText:{
    //     textAlign: 'center',
    //     padding: 10,
    //     color: '#cfd1d0',
    //     fontWeight: '400',
    // },
    // dataWrapper: { 
    //     marginTop: -1 
    // },
    rowText:{
        padding: 10,
        textAlign: 'center',
        color:'#070708',
        fontWeight: '300',
    },
})

export default Bills;